import { useDataContext } from 'context/DataStoreContext';
import { useApi } from 'model/Api';

export type Role = {
  id: number;
  code: string;
  name: string;
  permissions: { [permission: string]: boolean };
};

export const useRole = () => {
  const api = useApi();
  const { state, dispatch } = useDataContext();

  const getList = (): Role[] => {
    const roles = state?.role.list || [];
    if (!roles.length) {
      api.role.getsByOwn().then((rolesResponse) => {
        dispatch?.({ type: 'SET_ROLE_LIST', payload: rolesResponse });
      });
    }

    return roles;
  };

  const getListAsync = async (): Promise<Role[]> => {
    const stateRoles = state?.role.list || [];
    const roles = stateRoles.length
      ? stateRoles
      : (await api.role.getsByOwn()) || [];
    if (!stateRoles.length) {
      dispatch?.({ type: 'SET_ROLE_LIST', payload: roles });
    }

    return roles;
  };

  return { getList, getListAsync };
};
